import React from "react";
import { Switch, Redirect } from "react-router-dom";
import Dashboard from "../components/dashboardComponent/dashboard";
import Lending from "../components/lendingComponent/lending";
import { PublicRoute } from "./publicRoute";
import { PrivateRoute } from "./privateRoute";
import PageNotFound from "../components/pageNotFound/pageNotFound";
import Folders from "../components/foldersComponent/folders";
import Upload from "../components/uploadComponent/upload";
import Company from "../components/companyComponent/company";
import Member from "../components/companyComponent/member";
import Profile from "../components/profileComponent/profile";
import mapsView from "../components/mapPreview/mapVIew";
import DeactivationMessage from "../components/deactivationMessage/deactivationMessage";
import TermsAndConditions from "../components/policy/terms";

const Routes = () => {
    return (
        <Switch>
            {/* <PublicRoute path="/login" component={login} /> */}
            <PublicRoute path="/" component={Lending} exact />
            <PrivateRoute path="/dashboard" component={Dashboard} />
            <PublicRoute path='/msg' component={DeactivationMessage} />
            <PublicRoute path='/terms' component={TermsAndConditions} />
            <PublicRoute path='/pageNotFound' component={PageNotFound} />
            <Redirect to='/pageNotFound' />
        </Switch>
    );
};


const DashboardRoutes = () => {
    return (
        <Switch>
            <PrivateRoute path="/dashboard/folder" component={Folders} />
            <PrivateRoute path="/dashboard/upload" component={Upload} />
            <PrivateRoute path="/dashboard/company/:userId" component={Company} />
            <PrivateRoute path="/dashboard/member/:memberId" component={Member} />
            <PrivateRoute path="/dashboard/profile" component={Profile} />
            <PrivateRoute path="/dashboard/maps" component={mapsView} />
            <PrivateRoute component={PageNotFound} />
            <Redirect to='/pageNotFound' />
        </Switch>
    );
};

export { Routes, DashboardRoutes };



// WEBPACK FOOTER //
// ./src/routes/routes.js